import styled from 'styled-components';

import Box from '@mui/material/Box/Box';
import { colors, devices } from 'styles';

interface HeroSectionGradientProps {
  gradient: string;
}

export const HeroSectionWrapper = styled(Box)`
  position: relative;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  background-color: ${colors.mainDark};
  background-size: cover;
  background-attachment: fixed;
  background-position: 45px 45px;

  @media (${devices.lg}) {
    background-position: right center;
  }
`;

export const HeroSectionGradient = styled(Box)<HeroSectionGradientProps>`
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  background: ${({ gradient }) => gradient};
`;

const DefaultTriangle = styled(Box)`
  width: 100%;
  height: 0;
  border-top: calc(100vw / 13.5) solid transparent;
  border-bottom: calc(100vw / 13.5) solid transparent;
  z-index: 20;
  position: absolute;
  bottom: 0;
  overflow: hidden;
  transform: translateY(50%);
`;

export const LeftTriangle = styled(DefaultTriangle)`
  border-right: 50vw solid white;
  right: 0;
`;

export const RightTriangle = styled(DefaultTriangle)`
  border-left: 50vw solid white;
  left: 0;
`;

const DefaultTriangleTop = styled(Box)`
  width: 100%;
  height: 0;
  border-top: calc(100vw / 13.5) solid transparent;
  border-bottom: calc(100vw / 13.5) solid transparent;
  z-index: 20;
  position: absolute;
  top: 0;
  overflow: hidden;
  transform: translateY(-50%) rotate(180deg);
`;

export const LeftTriangleTop = styled(DefaultTriangleTop)`
  border-left: 50vw solid ${colors.mainDark};
  right: 0;
`;

export const RightTriangleTop = styled(DefaultTriangleTop)`
  border-right: 50vw solid ${colors.mainDark};
  left: 0;
`;
